import _ from 'lodash';
import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Col } from 'react-bootstrap';
import { FormManager } from 'blaze-form';
import '../../../styles/form/validationreport.scss';
import ModalContext from '../../modal/ModalContext';

const ValidationReport = ({ report, form, highlight }) => {
  const { close } = useContext(ModalContext);

  const renderFailureList = () => {
    return Object.keys(report.failed).map(fieldName => {
      const issues = report.failed[fieldName].errors.map(issue => issue.reason);
      const issueText = issues.join(' ');

      if (!form[fieldName]) {
        FormManager.warnFieldName(fieldName);
        return null;
      }

      const hidden = form[fieldName].hidden ? ' (Hidden)' : '';

      return (
        <Col className="issue-wrapper failed" sm={12} md={6} lg={4} key={fieldName}>
          <div
            className="validation-issue"
            onClick={() => {
              close();
              highlight(fieldName);
            }}
          >
            <i className="zmdi zmdi-arrow-right-top" />
            <div className="field-name">
              {form[fieldName].label}
              {hidden}
            </div>
            <div className="field-issues">{issueText}</div>
          </div>
        </Col>
      );
    });
  };

  const renderPassedList = () => {
    return Object.keys(report.results).map(fieldName => {
      // Skip sections, tables, and tabs
      if (/^(?:table|section|tab|step)$/.test(_.get(report.results[fieldName], 'config.type', ''))) {
        return null;
      }

      if (!form[fieldName]) {
        FormManager.warnFieldName(fieldName);
        return null;
      }

      // Skip hidden fields and fields with no label
      if (form[fieldName].hidden || !form[fieldName].label) {
        return null;
      }

      const hidden = form[fieldName].hidden ? ' (Hidden)' : '';

      return (
        <Col className="issue-wrapper passed" sm={12} md={6} lg={4} key={fieldName}>
          <div className="validation-issue">
            <div className="field-name">
              {form[fieldName].label}
              {hidden}
            </div>
          </div>
        </Col>
      );
    });
  };

  const validCount = Object.keys(report.results).length - Object.keys(report.failed).length;

  return (
    <div className="validation-report">
      <div className="all-bad">
        <i className="zmdi zmdi-close-circle" />
        <strong>{Object.keys(report.failed).length}</strong> failed
      </div>
      <div className="issue-list">{renderFailureList()}</div>
      <div className="clearfix" />
      <div className="all-good">
        <i className="zmdi zmdi-check-circle" />
        <strong>{validCount}</strong> passed
      </div>
      <div className="issue-list">{renderPassedList()}</div>
      <div className="clearfix" />
    </div>
  );
};

ValidationReport.propTypes = {
  form: PropTypes.object,
  highlight: PropTypes.func,
  report: PropTypes.object,
};

export default ValidationReport;
